import React, { useState } from 'react';
import { NavigationButton } from './NavigationButton.tsx';
import { faqData } from './FAQData.ts';

export function FAQ({ language, t }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(faqData[language].length - 1, prev + 1));
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-bold text-[--c-dark] mb-4">{t.commonQuestionTitle}</h2>
          <div className="w-32 h-1 bg-[--c-accent] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="bg-[--c-verylight] rounded-xl p-8 shadow-lg">
            <div className="min-h-[200px]">
              <h3 className="text-3xl font-semibold text-[--c-dark] mb-4">
                {faqData[language][currentIndex].question}
              </h3>
              <p className="text-[--c-main] leading-relaxed text-2xl">
                {faqData[language][currentIndex].answer}
              </p>
            </div>

            <div className="flex items-center justify-between mt-8">
              <NavigationButton
                direction="prev"
                onClick={handlePrev}
                disabled={currentIndex === 0}
              />
              <span className="text-sm text-[--c-main]">
                {currentIndex + 1} of {faqData[language].length}
              </span>
              <NavigationButton
                direction="next"
                onClick={handleNext}
                disabled={currentIndex === faqData[language].length - 1}
              />
            </div>
          </div>

          <div className="hidden lg:block">
            <img
              src={require('../../Styling/faq.png')}
              alt="Support illustration"
            />
          </div>

        </div>
      </div>
    </section>
  );
}